import moment from 'moment-mini'

import { Injectable } from '@angular/core'

import { RolePermissions } from './role-permissions'

@Injectable()
export class RolePermissionsSerializer {
  fromJson(json: any): RolePermissions {
    const rolePermissions = {
      ...json
    }

    return rolePermissions
  }

  toJson(rolePermissions: RolePermissions): any {
    return {
      ...rolePermissions
    }
  }
}
